<template>
  <section id="credit-explainer-instore">
    <h5 class="text-black py-0 mt-3 text-center">
      {{ t("CL_CONTRACT.APPROVED_CREDIT") }}
      <br />
      <span class="text-center pj-color-green fs-1">{{ amount }}</span>
    </h5>
    <div class="container">
      <div class="row">
        <div class="col-8 text-start">
          {{ t("CL_CONTRACT.COST_USE_IT") }}
        </div>
        <div class="col-4 text-end fw-bold">$0</div>
      </div>
      <div class="row">
        <div class="col-8 text-start">
          {{ t("CL_CONTRACT.MAXIMUM_WEEKLY_INTEREST") }}
        </div>
        <div class="col-4 text-end fw-bold">
          {{ percentageFormat((annualPercentageRate / 365) * 7) }}
        </div>
      </div>
      <div class="row">
        <div class="col-8 text-start">
          {{ t("CL_CONTRACT.WEEKLY_INSTALLMENTS") }}
        </div>
        <div class="col-4 text-end fw-bold">
          {{ paymentTerm }}
        </div>
      </div>
    </div>
    <div
      v-if="hideModal"
      @click="$emit('showModalInterestExp')"
      style="
        padding-right: calc(var(--bs-gutter-x) * 0.5);
        padding-left: calc(var(--bs-gutter-x) * 0.5);
        width: 100%;
        color: #2c7040;
        font-size: 15px;
        font-family: Nunito;
        font-weight: 600;
        cursor: pointer;
        line-height: 24px;
        word-wrap: break-word;
      "
    >
      {{ t("CL_CONTRACT.SEE_HOW_INTEREST_WORKS") }}
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import percentageFormat from "../../helpers/percentageFormatter.helper";
import { useI18n } from "@/apps/credit-line/composables/useI18n";

export default defineComponent({
  methods: { percentageFormat },
  props: {
    amount: String,
    annualPercentageRate: Number,
    paymentTerm: String,
    hideModal: Boolean,
  },
  name: "InStoreOfferSummary",
  emits: ["showModalInterestExp"],
  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
#credit-explainer-instore {
  background-color: $pj-color-nav-bar-gray;
  width: 120%;
  position: relative;
  padding-top: 1.13rem;
  padding-bottom: 0.81rem;
  left: -5%;

  & h5 {
    & span {
      color: $pj-color-green;
      font-family: Inter, serif;
      font-size: 2.25rem;
      font-style: normal;
      font-weight: 600;
      letter-spacing: 0.01125rem;
    }
  }

  & .container {
    & .row {
      margin-top: 0.5rem;
    }
  }
}

/*#credit-explainer::before,
#credit-explainer::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 10%;
  background-color: $pj-color-nav-bar-gray;
}

#credit-explainer::before {
  left: -2rem;
}

#credit-explainer::after {
  right: -2rem;
}*/
* {
  max-width: 100vw !important;
}
</style>
